module.exports = __webpack_public_path__ + "img/gesto.710c7671.png";